<script setup>
import { computed } from 'vue';
import FormSelect from 'v3/components/Form/Select.vue';
import { useFontSize } from 'dashboard/composables/useFontSize';

const props = defineProps({
  value: {
    type: String,
    default: 'default',
  },
  label: {
    type: String,
    default: '',
  },
  description: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['change']);

const { fontSizeOptions } = useFontSize();

const selectedValue = computed({
  get: () => props.value,
  set: value => {
    emit('change', value);
  },
});
</script>

<template>
  <div
    class="flex flex-col gap-3 justify-between w-full items-start sm:flex-row"
  >
    <div>
      <label
        for="fontSize"
        class="text-n-slate-12 font-medium leading-6 text-sm"
      >
        {{ label }}
      </label>
      <p class="mb-0 text-sm leading-6 text-n-slate-11">
        {{ description }}
      </p>
    </div>
    <FormSelect
      id="fontSize"
      v-model="selectedValue"
      name="fontSize"
      spacing="compact"
      class="w-full sm:w-32 shrink-0 mt-px"
      :value="selectedValue"
      :options="fontSizeOptions"
      label=""
    >
      <option
        v-for="option in fontSizeOptions"
        :key="option.value"
        :value="option.value"
        :selected="option.value === selectedValue"
      >
        {{ option.label }}
      </option>
    </FormSelect>
  </div>
</template>
